import { IEntityDateTime, IHasOwner, IIdName, IIdNameDateTime } from "./id-name";
import { IDeletedParam, IQueryStrictParams, IRequestParams } from "./page";
import { IShardClusterDetailsItem } from "./shard-cluster";

export interface IBucketListItem extends IIdNameDateTime<string>, IHasOwner {
    storagePoolId: string;
    bucketConfig: IBucketConfig;
    storagePool: IIdName<string>;
    applications: IIdName<string>[];
    url: string
}

export interface IBucketDetailsItem extends Omit<IBucketListItem, 'storagePool' | 'applications'>, IBucketLifecyclePolicy {
    tagURI: string;

    storagePool: IShardClusterDetailsItem;
}

export interface IBucketLifecyclePolicy {
    objectLock: boolean;
    objectVersioning: boolean;
    retentionDays?: number;
}

export interface IBucketConfig extends IEntityDateTime<string>, IBucketLifecyclePolicy {
    bucketId: string;
}

export enum BucketSortField {
    BucketId = "id",
    BucketName = "name",
    StoragePool = "pool",
}

export interface IBucketFilterParams extends IQueryStrictParams {
    pool?: string;
    free?: boolean;
}

export interface IBucketPageRequestParams extends
    IBucketRequestParams,
    IBucketFilterParams,
    IDeletedParam {
}

export interface IBucketUpdateRequest extends IIdName<string>, IBucketLifecyclePolicy {
}

export interface IBucketCreateRequest extends Omit<IBucketUpdateRequest, 'id'> {
    storagePoolId: string;
}

export interface IBucketRequestParams extends
    IRequestParams<BucketSortField>,
    IBucketFilterParams,
    IDeletedParam {

    fields?: (keyof IBucketListItem)[];
}
